// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".877bb12482463c8c023c7a550af7756b49ca4c18.chunk.bundle.js";
};